import React, { useState } from "react";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fab, fas, far);

const CFCollapse = (props) => {
  const [isOpen, setIsOpen] = useState(props.defaultOpen || false);

  const clickableText = () => {
    return (
      <div className="flex items-center justify-between">
        <p className="font-semibold text-xl m-0">{props.text}</p>
        <FontAwesomeIcon icon={isOpen ? "fas fa-chevron-up" : "fas fa-chevron-down"} size="xs" />
      </div>
    )
  }

  const clickableButton = () => {
    return (
      <div className="cursor-pointer rounded-xl w-full p-[10px] bg-slate-800 flex justify-center items-center text-white gap-2 text-lg">
        {props.text}
      </div>
    )
  }

  const clickableIcon = () => {
    return (
      <FontAwesomeIcon icon={props?.icon || "fa-chevron-down"} size="xs"/>
    )
  }

  return (
    <div className="cf-collapse flex flex-column">
      <div className="cf-collapse-header cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
        {props.style === 'text' || !props.style && clickableText()}
        {props.style === 'button' && clickableButton()}
        {props.style === 'icon' && clickableIcon()}
      </div>

      {isOpen && (
        <div className={`cf-collapse-content mt-5 ${props.className}`}>
          {props.children}
        </div>
      )}
    </div>
  );
};

CFCollapse.propTypes = {
  style: PropTypes.oneOf(['text', 'button', 'icon']),
  icon: PropTypes.string
}

export default CFCollapse;
